import { Card, CardBody, Col } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { IconInHeadings } from "../../../../Constant";
import { ICON_IN_HEADINGS } from "../../../../Data/Bonus Ui/BasicCard";
import { Image, P } from "../../../../AbstractElements";
import { dynamicImage } from "../../../../Service/DynamicImage";

const IconInHeading = () => {
  const LibraryIcon = () => {
    return <i className="icofont icofont-library me-2"></i>;
  };
  
  return (
    <Col sm="12" xl="6">
      <Card>
        <CommonCardHeader title={IconInHeadings} span={ICON_IN_HEADINGS} headerClass={true} icon={<LibraryIcon />} />
        <CardBody>
          <div className="flex-space flex-wrap align-items-center">
            <Image className="tab-img" src={dynamicImage("avtar/3.jpg")} alt="profile" />
            <P><strong>Visit Us: </strong> 2600 Hollywood Blvd,Florida, United States- 33020<br /><strong>Mail Us:</strong>contact@us@gmail.com<br /><strong>Contact Number: </strong>(954) 357-7760</P>
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

export default IconInHeading;
